import { render, staticRenderFns } from "./ShopCategory.vue?vue&type=template&id=efebdbde&scoped=true"
import script from "./ShopCategory.vue?vue&type=script&lang=js"
export * from "./ShopCategory.vue?vue&type=script&lang=js"
import style0 from "./ShopCategory.vue?vue&type=style&index=0&id=efebdbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efebdbde",
  null
  
)

export default component.exports